<template>
  <nav class="px-0">
    <div class="nav nav-tabs mes-tabs" id="nav-tab" role="tablist">
      <button
        class="nav-link mes-tab"
        :class="{ active: tabIndex == 0 }"
        id="nav-inspection-first-tab"
        data-bs-toggle="tab"
        data-bs-target="#nav-inspection-first"
        type="button"
        role="tab"
        aria-controls="nav-inspection-first"
        aria-selected="true"
        @click="tabIndex = 0"
      >
        首件檢查
      </button>
      <button
        class="nav-link mes-tab"
        :class="{ active: tabIndex == 1 }"
        id="nav-inspection-self-tab"
        data-bs-toggle="tab"
        data-bs-target="#nav-inspection-self"
        type="button"
        role="tab"
        aria-controls="nav-inspection-self"
        aria-selected="false"
        @click="tabIndex = 1"
      >
        自主檢查
      </button>
      <button
        class="nav-link mes-tab"
        :class="{ active: tabIndex == 2 }"
        id="nav-inspection-last-tab"
        data-bs-toggle="tab"
        data-bs-target="#nav-inspection-last"
        type="button"
        role="tab"
        aria-controls="nav-inspection-last"
        aria-selected="false"
        @click="tabIndex = 2"
      >
        末件檢查
      </button>
    </div>
  </nav>
  <div class="tab-content inspectionList-tab-content pb-2" id="nav-tabContent">
    <div
      class="tab-pane fade"
      :class="{
        'show active': tabIndex == 0,
      }"
      id="nav-inspection-first"
      role="tabpanel"
      aria-labelledby="nav-inspection-first-tab"
    >
      <div class="row mx-0">
        <div
          class="col-12 text-end pe-3"
          style="height: 2.5rem; line-height: 2.5rem;"
        >
          主管確認：{{ inspectionData.leaders ? inspectionData.leaders.first : '' }}
        </div>
        <template v-if="inspectionData.first.length === 0">
          <div class="col-12 mt-3 text-start">
            <span>第1支工件</span>
            <commonTable
              :fields="inspectionFields"
              :items="[]"
              :tableClass="'text-center'"
              stickyHeader="179px"
            />
          </div>
          <div class="col-12 mt-3 text-start">
            <span>第2支工件</span>
            <commonTable
              :fields="inspectionFields"
              :items="[]"
              :tableClass="'text-center'"
              stickyHeader="179px"
            />
          </div>
        </template>
        <template v-else>
          <template
            v-for="(inspectionValue, nth) in inspectionData.first"
            :keys="nth"
          >
            <template v-for="(list, count) in inspectionValue" :keys="count">
              <div class="col-12 mt-3 text-start">
                <span>第{{ count + 1 }}支工件</span>
                <commonTable
                  :fields="inspectionFields"
                  :items="list.inspection"
                  :tableClass="'text-center'"
                  stickyHeader="179px"
                >
                  <template #cell(time)="row">
                    {{ row.value.split(".")[0] }}
                  </template>
                </commonTable>
              </div>
            </template>
          </template>
        </template>
      </div>
    </div>
    <div
      class="tab-pane fade"
      :class="{
        'show active': tabIndex == 1,
      }"
      id="nav-inspection-self"
      role="tabpanel"
      aria-labelledby="nav-inspection-self-tab"
    >
      <div class="row mx-0">
        <div
          class="col-12 text-end pe-3"
          style="height: 2.5rem; line-height: 2.5rem;"
        >
          主管確認：{{ inspectionData.leaders ? inspectionData.leaders.self : '' }}
        </div>
        <template v-if="inspectionData.self.length === 0">
          <div class="col-12 mt-3 text-start">
            <span>第1支工件</span>
            <commonTable
              :fields="inspectionFields"
              :items="[]"
              :tableClass="'text-center'"
              stickyHeader="179px"
            />
          </div>
          <div class="col-12 mt-3 text-start">
            <span>第2支工件</span>
            <commonTable
              :fields="inspectionFields"
              :items="[]"
              :tableClass="'text-center'"
              stickyHeader="179px"
            />
          </div>
        </template>
        <template v-else>
          <div class="col-12 mt-1 text-start">
            <template
              v-for="(inspectionValue, nth) in inspectionData.self"
              :keys="nth"
            >
              <button
                class="btn inspectionList-btn me-2 mb-1"
                :class="{ active: button_select == nth }"
                @click="button_select = nth"
              >
                {{ nth }}
              </button>
            </template>
          </div>
          <template
            v-for="(list, count) in inspectionData.self[button_select]"
            :keys="count"
          >
            <div class="col-12 mt-3 text-start">
              <span>第{{ count + 1 }}支工件</span>
              <commonTable
                :fields="inspectionFields"
                :items="list.inspection"
                :tableClass="'text-center'"
                stickyHeader="179px"
              >
                <template #cell(time)="row">
                  {{ row.value.split(".")[0] }}
                </template>
              </commonTable>
            </div>
          </template>
        </template>
      </div>
    </div>
    <div
      class="tab-pane fade"
      :class="{
        'show active': tabIndex == 2,
      }"
      id="nav-inspection-last"
      role="tabpanel"
      aria-labelledby="nav-inspection-last-tab"
    >
      <div class="row mx-0">
        <div
          class="col-12 text-end pe-3"
          style="height: 2.5rem; line-height: 2.5rem;"
        >
          主管確認：{{ inspectionData.leaders ? inspectionData.leaders.last : '' }}
        </div>
        <template v-if="inspectionData.last.length === 0">
          <div class="col-12 mt-3 text-start">
            <span>第1支工件</span>
            <commonTable
              :fields="inspectionFields"
              :items="[]"
              :tableClass="'text-center'"
              stickyHeader="179px"
            />
          </div>
          <div class="col-12 mt-3 text-start">
            <span>第2支工件</span>
            <commonTable
              :fields="inspectionFields"
              :items="[]"
              :tableClass="'text-center'"
              stickyHeader="179px"
            />
          </div>
        </template>
        <template v-else>
          <template
            v-for="(inspectionValue, nth) in inspectionData.last"
            :keys="nth"
          >
            <template v-for="(list, count) in inspectionValue" :keys="count">
              <div class="col-12 mt-3 text-start">
                <span>第{{ count + 1 }}支工件</span>
                <commonTable
                  :fields="inspectionFields"
                  :items="list.inspection"
                  :tableClass="'text-center'"
                  stickyHeader="179px"
                >
                  <template #cell(time)="row">
                    {{ row.value.split(".")[0] }}
                  </template>
                </commonTable>
              </div>
            </template>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "@vue/runtime-core";
import commonTable from "@/components/commonTable.vue";
export default {
  props: {
    inspectionData: Object,
  },
  components: {
    commonTable,
  },
  setup() {
    const tabIndex = ref(0);
    const button_select = ref(1);
    const inspectionFields = [
      {
        key: "time",
        label: "檢驗時間",
        thStyle: {
          "min-width": "180px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "inspector",
        label: "檢測人員",
        thStyle: {
          "min-width": "80px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "code",
        label: "檢驗項目",
        thStyle: {
          "min-width": "80px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "standardValue",
        label: "標準值",
        thStyle: {
          "min-width": "115px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "inspectionValue",
        label: "檢驗值",
        thStyle: {
          "min-width": "80px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "result",
        label: "檢驗結果",
        thStyle: {
          "min-width": "80px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
    ];
    return { tabIndex, button_select, inspectionFields };
  },
};
</script>

<style>
.inspectionList-tab-content {
  background-color: var(--main-font-color);
}
.inspectionList-btn {
  height: 2rem;
  padding: 0;
  width: 4.25rem;
  color: var(--main-font-color);
  background-color: var(--main-status-secondary-color);
  border-color: var(--main-status-secondary-color);
}
.inspectionList-btn:hover {
  color: var(--main-font-color);
}
.inspectionList-btn.active {
  background-color: var(--main-bg-color);
  border-color: var(--main-bg-color);
}
</style>
